import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { Card, CardBody, Container, Button, Spinner } from 'reactstrap';
import useGet from '../../helpers/hooks/useGet';
import usePatch from '../../helpers/hooks/usePatch';
import usePost from '../../helpers/hooks/usePost';

import { AddDistrict } from './add-district';

import { DistrictsList } from './districts-list';

export const Districts = (props) => {
  const [showAddForm, setShowAddForm] = useState(false);
  const [districts, , districtsLoading, loadDistricts] = useGet(
    '/districts?filter[order]=createdAt DESC',
    true
  );
  const [postData, postedData, postingError, dataPosting] = usePost(
    '/districts'
  );
  const [updateData, updatedData, updatingError, dataUpdating] = usePatch('');
  const handleAddNewDistrict = (event, errors, values) => {
    console.log(values, errors);
    if (errors.length === 0) {
      postData({ ...values });
    }
  };
  const handleDistrictPatch = (id, data) => {
    updateData(data, `/districts/${id}`);
  };
  useEffect(() => {
    if (postedData) {
      setShowAddForm(false);
      loadDistricts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postedData]);
  useEffect(() => {
    if (updatedData) {
      loadDistricts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedData]);
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <div className='align-items-end d-flex justify-content-between mb-3'>
            <h4>Districts</h4>
            {/* <Button
              color='primary'
              onClick={() => setShowAddForm(!showAddForm)}
            >
              Add New District
            </Button> */}
          </div>
          {showAddForm && (
            <AddDistrict onAdd={handleAddNewDistrict} disabled={dataPosting} />
          )}
          <Card>
            <CardBody>
              {districtsLoading || dataUpdating ? (
                <div className='text-center'>
                  <Spinner className='mr-2' color='primary' />
                </div>
              ) : (
                <DistrictsList
                  onUpdate={handleDistrictPatch}
                  data={districts?.map((x, i) => ({
                    ...x,
                    srNo: i + 1,
                    createdAt: dayjs(x.createdAt).format('DD/MM/YYYY'),
                    updatedAt: dayjs(x.updatedAt).format('DD/MM/YYYY'),
                    actions: (
                      <Link to={`/district-details/${x.id}`}> 
                      <Button color='primary' >Edit</Button>
                      </Link>
                      
                    ),
                  }))}
                />
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
};
